<template>
    <Loading>
        <div class="p-4">
            <div class="education-item outline py-2 px-3">
                <div class="m-auto">
                    <Row class="image-row" rounded />
                </div>
                <div class="center w-100 h-100 flew-grow mr-4 ml-4">
                    <Row class="text-row" rounded />
                    <Row class="mb-3" rounded />
                    <Row class="w-50 mbtm-0" rounded />
                </div>
                <div class="m-auto h-100 d-flex align-items-center">
                    <Avatar style="width:30px;height:30px;" />
                </div>
            </div>
            <Row class="input-row mt-3" rounded />
        </div>
    </Loading>
</template>

<script>
import Loading from '~/components/skeletons/base/Loading';
import Avatar from '~/components/skeletons/base/Avatar';
import Row from '~/components/skeletons/base/Row';

export default {
    name: 'EducationSkeleton',
    components: { Loading, Avatar, Row },
};
</script>

<style scoped>
.outline {
    border: 1px solid rgb(230, 230, 230);
    border-radius: 3px;
}

.education-item {
    display: flex;
}

.image-row {
    width: 64px;
    height: 64px;
    margin-bottom: 0px !important;
}

.input-row {
    height: 38px;
}

.text-row {
    width: 120px;
}

.mbtm-0 {
    margin-bottom: 0px !important;
}

@media only screen and (max-width: 600px) {
    .education-item {
        flex-direction: column;
        align-items: center;
    }

    .education-item > div {
        margin-right: 0px !important;
        margin-left: 0px !important;
        margin-bottom: 20px !important;
    }

    .center {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
}
</style>
